module.exports = __webpack_public_path__ + "img/youtube-clone.16fc9461.png";